"use client"

import { useState } from "react"
import { FaBars, FaBell, FaEnvelope, FaSearch, FaUser } from "react-icons/fa"
import { useNavigate } from "react-router-dom";

const Navbar = ({ toggleSidebar }) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const [showMessages, setShowMessages] = useState(false)
const navigate = useNavigate();
  const notifications = [
    { id: 1, text: "New user registered", time: "2 min ago" },
    { id: 2, text: "Course approval pending", time: "1 hour ago" },
    { id: 3, text: "Payment received", time: "3 hours ago" },
  ]

  const messages = [
    { id: 1, sender: "John Doe", text: "When will the new course be approved?", time: "10 min ago" },
    { id: 2, sender: "Jane Smith", text: "I need help with billing", time: "1 hour ago" },
  ]

  const handleLogout = () => {
  // Remove token
  localStorage.removeItem("jwttoken");
  navigate("/Log");

};

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        background: "white",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        zIndex: 10,
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <button
          onClick={toggleSidebar}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "20px",
            marginRight: "20px",
            color: "#7366ff",
          }}
        >
          <FaBars />
        </button>
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            background: "#f5f5f5",
            borderRadius: "20px",
            padding: "5px 15px",
            width: "300px",
          }}
        >
          <FaSearch style={{ color: "#888", marginRight: "10px" }} />
          <input
            type="text"
            placeholder="Search..."
            style={{
              border: "none",
              background: "transparent",
              outline: "none",
              width: "100%",
            }}
          />
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ position: "relative", marginRight: "20px" }}>
          <button
            onClick={() => {
              setShowNotifications(!showNotifications)
              setShowMessages(false)
              setShowDropdown(false)
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "20px",
              color: "#7366ff",
              position: "relative",
            }}
          >
            <FaBell />
            <span
              style={{
                position: "absolute",
                top: "-5px",
                right: "-5px",
                background: "#ff5baf",
                color: "white",
                borderRadius: "50%",
                width: "16px",
                height: "16px",
                fontSize: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              3
            </span>
          </button>
          {showNotifications && (
            <div
              style={{
                position: "absolute",
                top: "40px",
                right: "-10px",
                background: "white",
                boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                width: "300px",
                zIndex: 100,
              }}
            >
              <div style={{ padding: "15px", borderBottom: "1px solid #eee" }}>
                <h3 style={{ margin: 0 }}>Notifications</h3>
              </div>
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {notifications.map((notification) => (
                  <div
                    key={notification.id}
                    style={{
                      padding: "10px 15px",
                      borderBottom: "1px solid #f5f5f5",
                      cursor: "pointer",
                      transition: "background 0.2s",
                      ":hover": { background: "#f9f9f9" },
                    }}
                  >
                    <div style={{ fontWeight: "bold" }}>{notification.text}</div>
                    <div style={{ fontSize: "12px", color: "#888" }}>{notification.time}</div>
                  </div>
                ))}
              </div>
              <div style={{ padding: "10px 15px", textAlign: "center" }}>
                <a href="#" style={{ color: "#7366ff", textDecoration: "none" }}>
                  View all notifications
                </a>
              </div>
            </div>
          )}
        </div>

        <div style={{ position: "relative", marginRight: "20px" }}>
          <button
            onClick={() => {
              setShowMessages(!showMessages)
              setShowNotifications(false)
              setShowDropdown(false)
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "20px",
              color: "#7366ff",
              position: "relative",
            }}
          >
            <FaEnvelope />
            <span
              style={{
                position: "absolute",
                top: "-5px",
                right: "-5px",
                background: "#ff5baf",
                color: "white",
                borderRadius: "50%",
                width: "16px",
                height: "16px",
                fontSize: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              2
            </span>
          </button>
          {showMessages && (
            <div
              style={{
                position: "absolute",
                top: "40px",
                right: "-10px",
                background: "white",
                boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                width: "300px",
                zIndex: 100,
              }}
            >
              <div style={{ padding: "15px", borderBottom: "1px solid #eee" }}>
                <h3 style={{ margin: 0 }}>Messages</h3>
              </div>
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {messages.map((message) => (
                  <div
                    key={message.id}
                    style={{
                      padding: "10px 15px",
                      borderBottom: "1px solid #f5f5f5",
                      cursor: "pointer",
                      transition: "background 0.2s",
                      ":hover": { background: "#f9f9f9" },
                    }}
                  >
                    <div style={{ fontWeight: "bold" }}>{message.sender}</div>
                    <div>{message.text}</div>
                    <div style={{ fontSize: "12px", color: "#888" }}>{message.time}</div>
                  </div>
                ))}
              </div>
              <div style={{ padding: "10px 15px", textAlign: "center" }}>
                <a href="#" style={{ color: "#7366ff", textDecoration: "none" }}>
                  View all messages
                </a>
              </div>
            </div>
          )}
        </div>

        <div style={{ position: "relative" }}>
          <button
            onClick={() => {
              setShowDropdown(!showDropdown)
              setShowNotifications(false)
              setShowMessages(false)
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                background: "linear-gradient(45deg, #ff5baf, #7366ff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                marginRight: "10px",
              }}
            >
              <FaUser />
            </div>
            <div style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
              <span style={{ fontWeight: "bold" }}>Admin User</span>
              <span style={{ fontSize: "12px", color: "#888" }}>Super Admin</span>
            </div>
          </button>
          {showDropdown && (
            <div
              style={{
                position: "absolute",
                top: "50px",
                right: "0",
                background: "white",
                boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                width: "200px",
                zIndex: 100,
              }}
            >
              <div style={{ padding: "10px 15px", borderBottom: "1px solid #f5f5f5" }}>
                <a href="#" style={{ display: "block", padding: "5px 0", color: "#333", textDecoration: "none" }}>
                  Profile
                </a>
              </div>
              <div style={{ padding: "10px 15px", borderBottom: "1px solid #f5f5f5" }}>
                <a href="#" style={{ display: "block", padding: "5px 0", color: "#333", textDecoration: "none" }}>
                  Settings
                </a>
              </div>
              <div style={{ padding: "10px 15px" }}>
                <a
  onClick={handleLogout}
  style={{
    display: "block",
    padding: "5px 0",
    color: "#333",
    textDecoration: "none",
    cursor: "pointer"
  }}
>
  Logout
</a>

              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Navbar
